import styled from 'styled-components';
import { StyledBadgeProps } from './Badge.types';

export const StyledBadge = styled.span<StyledBadgeProps>`
  display: inline-block;
  padding: ${(props: StyledBadgeProps) => props.padding};
  border-radius: ${(props: StyledBadgeProps) => props.borderRadius};
  font-weight: 600;
  font-size: 15px;
  line-height: 24px;
  color: ${(props: StyledBadgeProps) => props.color};
  background-color: ${(props: StyledBadgeProps) => props.backgroundColor};

  ${(props) => props.customStyle}
`;
